/**
 * Telefonul in forma pe care o cere backendul: 10 cifre, national («0722123456»).
 *
 * De ce exista: `users.telefon` e stocat cum a fost scris la inscriere, deci si «+40722123456»,
 * iar DTO-urile de comanda au `@Pattern("\\d{10}")`. Un formular precompletat din profil trimitea
 * valoarea ca atare si primea 400, fara ca omul sa fi tastat ceva (07.10, comanda de recipient DBA).
 *
 * Drumul invers (national -> `tel:+40…`) e `hrefTelefon`, din `contact-ecotic.ts`.
 *
 * Ce nu recunoaste lasa NESCHIMBAT (doar fara spatiile de la capete): validarea de dupa trebuie sa
 * poata spune ca numarul e gresit, nu sa primeasca o ghicitoare.
 */
export function telefonNational(telefon: string | null | undefined): string {
    const t = String(telefon ?? '').trim();
    if (!t) return '';

    // Doar cifre si separatori obisnuiti; orice altceva (litere, interior) nu e treaba noastra.
    if (!/^\+?[\d\s().-]+$/.test(t)) return t;

    const cifre = t.replace(/\D/g, '');
    if (cifre.length === 13 && cifre.startsWith('0040')) return `0${cifre.slice(4)}`;
    if (cifre.length === 11 && cifre.startsWith('40')) return `0${cifre.slice(2)}`;
    // Un «+» cu alt prefix de tara nu devine numar national prin stergerea plusului.
    if (t.startsWith('+')) return t;
    return cifre;
}

/** Exact ce verifica backendul: `\d{10}`. */
export function esteTelefonNational(telefon: string): boolean {
    return /^\d{10}$/.test(telefon);
}

/** Modelul de numar corect, aratat in mesajele de eroare (cerut de owner, 07.10). */
export const EXEMPLU_TELEFON = '0700123456';

/**
 * Telefonul cum il citeste un om: «0700 123 456». Variabila de build il poate avea in format
 * international («+40700123456»); in text il vrem national, grupat 4-3-3. Ce nu e un numar
 * national de 10 cifre ramane cum a fost scris.
 */
export function telefonAfisat(telefon: string | null | undefined): string {
    const national = telefonNational(telefon);
    if (!esteTelefonNational(national)) return String(telefon ?? '').trim();
    return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
}
